$(function () {
  // check safari
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    $('body').addClass('u-safari');
  }

  if (navigator.userAgent.indexOf('Mac') != -1) {
    $('body').addClass('u-mac');
  }
  
  $(window).scroll(function() {
    let top =  parseInt($('html').css('--announcement-bar-height'));
    if ( $(window).scrollTop() > top){
        $('.header').addClass('is--sticky');
    }else{
        $('.header').removeClass('is--sticky');
    }
   
  });
  if ($('.list-collections').length > 0) {
    $('.shopify-section--collection-list .list-collections--carousel-medium .list-collections__item-list').each(function(){
      let $carousel = $(this);
      let $colorWrapper = $carousel.closest('.vertical-breather');
      let $prevArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow-medium .prev-next-button--prev');
      let $nextArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow-medium .prev-next-button--next');
      $carousel.slick({
        infinite: false,
        slidesToShow: 2.55,
        slidesToScroll: 1,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        dots: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1.291,
              slidesToScroll: 1,
              speed: 300
            }
          }
        ]
      });
    });
    $('.list-collections--carousel-large .list-collections__item-list').slick({
      infinite: false,
      slidesToShow: 1.45,
      slidesToScroll: 1,
      prevArrow: $('.shopify-section--collection-list .list-collections__arrow-large .prev-next-button--prev'),
      nextArrow: $('.shopify-section--collection-list .list-collections__arrow-large .prev-next-button--next'),
      dots: false,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  
  if ($('.product-list__inner-carousel').length > 0) {
    let numberProduct = 4;
    if($('.template-index').length > 0)
      numberProduct = 3;

    $('.section--collections .product-list__inner-carousel').each(function(){
      var $carousel = $(this);
      var $colorWrapper = $carousel.closest('.section__color-wrapper');
      var $prevArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow .prev-next-button--prev');
      var $nextArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow .prev-next-button--next');
  
      $carousel.slick({
        infinite: false,
        slidesToShow: numberProduct,
        slidesToScroll: 1,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        dots: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              infinite: false,
              slidesToShow: 1.289,
              slidesToScroll: 1
            }
          }
        ]
      });
    });

  }
  if ($(".article__banner").length > 0) {
    $('.article__banner .banner__slider').slick({
      infinite: false,
      slidesToShow: 1.513,
      slidesToScroll: 1,
      dots: false,
      prevArrow: $('.article__banner .prev-next-button--prev'),
      nextArrow: $('.article__banner .prev-next-button--next'),
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1.07,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  if ($('.article-list__inner-carousel').length > 0) {
    $('.section--article-list .article-list__inner-carousel').each(function(){
      var $carousel = $(this);
      var $colorWrapper = $carousel.closest('.section--article-list');
      var $prevArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow .prev-next-button--prev');
      var $nextArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow .prev-next-button--next');
  
      $carousel.slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        dots: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              infinite: false,
              slidesToShow: 1.289,
              slidesToScroll: 1
            }
          }
        ]
      });
    });

  }
  //slider bannerArea
  function showSliderBannerArea (){
    if($(window).width() <= 768){
      $('.js-bannerArea').not(".slick-initialized").slick({
        arrows: false,
        infinite: true,	
        dots: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    
    } else{
      $(".js-bannerArea").hasClass("slick-initialized") && $(".js-bannerArea").slick("unslick");
    }
  }

  showSliderBannerArea();
  $(window).on('resize', function(){
    showSliderBannerArea();
  });

  if ($('.shopify-section--customBlogPost').length > -1) {
    $( ".shopify-section--customBlogPost .tabs-nav__item-list .tabs-nav__item.js-showTab" ).on('click', function(){
      $( ".shopify-section--customBlogPost .tabs-nav__item-list .tabs-nav__item.js-showTab" ).removeClass("is-active"); 
      $( this ).addClass('is-active');
    }); 
    
    // change blog tag in section
    if ($('.shopify-section--customBlogPost .tabs-nav__item-list .tabs-nav__item.js-showTab.all-article').length) {
      var handle_fit = $('.shopify-section--customBlogPost .tabs-nav__item-list .tabs-nav__item.js-showTab.all-article').attr('data-handle');
      var url_fit =  window.location.origin + '/blogs/' + handle_fit;
      fetch(url_fit)
        .then((res) => res.text())
        .then((html) => {
          let page_content = document.querySelector(".shopify-section--customBlogPost .section__content--wrapper.js-showContent");
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var content_html = doc.querySelector('.shopify-section--main-blog .vertical-breather>.container').innerHTML;
          page_content.innerHTML = content_html;
        });
    }
    $('.shopify-section--customBlogPost .tabs-nav__item-list .tabs-nav__item.js-showTab.tag-article').click(function () {
      if ($('.shopify-section--customBlogPost .tabs-nav__item-list .tabs-nav__item.js-showTab.is-active').length) {
        var data_tag = $(this).attr('tag-id');
        var handle_fit = $(this).attr('data-handle');
        var url_fit = window.location.origin + '/blogs/' + handle_fit + '/tagged/' + data_tag;
        fetch(url_fit)
          .then((res) => res.text())
          .then((html) => {
            let page_content = document.querySelector(".shopify-section--customBlogPost .section__content--wrapper.js-showContent");
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            var content_html = doc.querySelector('.shopify-section--main-blog .vertical-breather>.container').innerHTML;
            page_content.innerHTML = content_html;
          });
      }
    })
     $('.shopify-section--customBlogPost .tabs-nav__item-list .tabs-nav__item.js-showTab.all-article').click(function () {
      if ($('.shopify-section--customBlogPost .tabs-nav__item-list .tabs-nav__item.js-showTab.is-active').length) {
        var handle_fit = $(this).attr('data-handle');
        var url_fit = window.location.origin + '/blogs/' + handle_fit;
        fetch(url_fit)
          .then((res) => res.text())
          .then((html) => {
            let page_content = document.querySelector(".shopify-section--customBlogPost .section__content--wrapper.js-showContent");
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            var content_html = doc.querySelector('.shopify-section--main-blog .vertical-breather>.container').innerHTML;
            page_content.innerHTML = content_html;
          });
      }
    })
  }
  
  if ($('.js-sliderShop').length > 0) {
    $('.js-sliderShop').each(function(){
      $(this).on('init', function(event, slick){
        if ($(this).find('.slick-dots li').length <= 1){
          $(this).find('.slick-dots').hide();
        }
      });
      $(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, 
          dots: true,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          autoplay:true,
          autoplaySpeed:2000
      });
    });
  }
  if ($('.option-group').length > 0) {
    const modal = $(".js-modal");
    //open modal
    $(".js-modal-open").on("click", function () {

      //added by suzuki
      //reset first
      let popup = $(this).closest(".tab-item").data("popup");
      let data_cate = $(this).closest(".option-group").data("cate");
      console.log(popup);

      
      $(".js-modal .js_popup_title").text(popup[0].title);
      $(".js-modal .c-modal__btn").attr('data-name', popup[0].title);
      $(".js-modal .c-modal__btn").attr('data-name-cate', data_cate);
      
      $(".js-modal .js_popup_eng").text("");
      if(popup[0].english) {
        $(".js-modal .js_popup_eng").text(popup[0].english);
      }
      $(".js-modal .js_popup_des").text("");
      $(".js-modal .js_popup_des").text(popup[0].description);
      
      $(".js-modal .js_popup_where").text("");
      if(popup[0].where) {
        $(".js-modal .js_popup_where").text("生産国："+popup[0].where);
      }

      //material
      $(".js-modal .js_popup_material *").remove();
      if(popup[0].material) {
        let material = popup[0].material;
        material = material.split(',');
        for (const item of material) {
          $(".js-modal .js_popup_material").append('<li class="c-modal__descItem">'+item+'</li>');
        }
      }
      //洗濯
      $(".js-modal .js_popup_wash *").remove();
      if(popup[0].washable) {
        $('.c-modal__laundryTitle').show();
        let washable = popup[0].washable;
        if (washable.length == 0){ 
          $('.c-modal__laundryTitle').hide() 
        }

        for (const item of washable) {
          $(".js-modal .js_popup_wash").append(`
            <div class="c-modal__laundryItem">
              <div class="c-modal__laundryImgWrap">
                <img src="${item[0]}" alt="img" />
              </div>
              <p class="c-modal__laundryDesc">${item[1]}</p>
            </div>
          `);
        }
      }else{
         $('.c-modal__laundryTitle').hide() 
      }
      //画像
      $(".js-modal .js_popup_imgs *").remove();
      if(popup[0].imgs) {
        let imgs = popup[0].imgs;
        for (const item of imgs) {
          $(".js-modal .js_popup_imgs").append(`
          <img class="c-modal__img" src="${item[0]}" alt="${item[1]}" />
          `);
        }
      }


      modal.addClass("is-active");
    });
    $('.c-modal__btn').attr('data-name','');
    $('.c-modal__btn').click(function (e) {
      event.preventDefault();
      let name = $(this).attr('data-name');
      let data_cate = $(this).attr('data-name-cate');
      $('.option-group[data-cate="'+data_cate+'"] input[data-display="'+name+'"]').trigger("click");
      modal.removeClass("is-active");
    })
    //close modal
    $(".js-modal-close").on("click", function () {
      modal.removeClass("is-active");
    });
  }

  
  if ($('.shopify-section--product-recommendations').length > 0) {
      let checkExistRecommendations = setInterval(function () {
      let $item = $('.recommendations-complete .product-list__inner-carousel');
      if ($item.length) {
        clearInterval(checkExistRecommendations);
        
        let $carousel = $item;
        let $colorWrapper = $carousel.closest('.section__color-wrapper');
        let $prevArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow .prev-next-button--prev');
        let $nextArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow .prev-next-button--next');
    
        $carousel.slick({
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          prevArrow: $prevArrow,
          nextArrow: $nextArrow,
          dots: false,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                infinite: false,
                slidesToShow: 1.289,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }, 100); // check every 100ms
  }

  if ($('.shopify-section--recently-viewed-products').length > 0) {
      let checkExistRecommendations = setInterval(function () {
      let $item = $('.recently-viewed-complete .product-list__inner-carousel');
      if ($item.length) {
        clearInterval(checkExistRecommendations);
        
        let $carousel = $item;
        let $colorWrapper = $carousel.closest('.section__color-wrapper');
        let $prevArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow .prev-next-button--prev');
        let $nextArrow = $colorWrapper.find('.section__header--wrapper .list-collections__arrow .prev-next-button--next');
    
        $carousel.slick({
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          prevArrow: $prevArrow,
          nextArrow: $nextArrow,
          dots: false,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                infinite: false,
                slidesToShow: 1.289,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }, 100); // check every 100ms
  }
  
   if ($('.js-bannerTabSlider').length > 0) {
      let $colorWrapper = $('.js-bannerTabSlider').closest('.tab-image');
      let $prevArrow = $colorWrapper.find('.list-collections__arrow .prev-next-button--prev');
      let $nextArrow = $colorWrapper.find('.list-collections__arrow .prev-next-button--next');
      $('.js-bannerTabSlider').not(".slick-initialized").slick({
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        infinite: true,	
        dots: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '53px',
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              centerPadding: '30px'
            }
          }
        ]
      });

      // var leftElements = document.querySelectorAll('.appended-item--left');
      $(window).on('resize', function(){
       

        // if($(".template-product .option-total").length > 0){
        //   if($(window).width() >= 1000){
        //     leftElements.forEach(function(element) {
        //         element.style.width = 'auto';
        //         element.style.minWidth = '1px';
        //     });
        //     checkWidthOptionProduct(leftElements);
        //   }
        // }
      });
   }
    // function checkWidthOptionProduct(){
    //   if($(".template-product .option-total").length > 0){
    //     let maxWidth = 0;
    //     leftElements.forEach(function(element) {
    //         const elementWidth = element.clientWidth;
    //         if (elementWidth > maxWidth) {
    //             maxWidth = elementWidth;
    //         }
    //     });
    //     const totalItems = document.querySelectorAll('.total-item');
    //     const fortyPercentWidth = 0.4 * totalItems[0].clientWidth;
    //     if (maxWidth > fortyPercentWidth) {
    //         leftElements.forEach(element => {
    //             element.style.whiteSpace = 'normal';
    //             element.style.minWidth = '1px';
    //             element.style.width = '40%';
    //         });
    //     }
    //     else{
    //       leftElements.forEach(function(element) {
    //           element.style.width = maxWidth + 'px';
    //           element.style.minWidth = (maxWidth + 1) + 'px';
    //           element.style.whiteSpace = 'normal';
    //       });
    //     }
    //   }
    // }

    // checkWidthOptionProduct();

  if ($('.template-customers-addresses').length > 0) {
    $(".p-postal-code").on('keypress', function (e) { 
      setTimeout(function() {
        const valueOption = $('.js-changeOption option:selected').data('value');
        if (valueOption != 'underfined') {
          $(".select.p-region-id-custom").val(valueOption).change();
          $('.p-locality').addClass("is-filled");
          $('.p-street-address').addClass("is-filled");
        }
      }, 500);
    })
  }
  
  if($(".template-product").length > 0){
    $(".js-scrollToSection").click(function () {
        $("html, body").animate({
            scrollTop: $(".c-procduct-option").offset().top - 50
        }, 1000); 
    });
  }


  // -- Total result - Search page --
  if ($('.template-search').length > 0) {
    let checkExistTotalResult = setInterval(function () {
      let totalResult = $('.template-search .boost-sd__product-count');
      if (totalResult.length > 0) {
        clearInterval(checkExistTotalResult);
        let textTotalResult = totalResult.text();
        let numberTotalResult = textTotalResult.match(/\d+/);
        if (numberTotalResult !== null) {
          console.log(numberTotalResult);

          let newSpanTotalResult = $("<span>").addClass("c-total-result").text(numberTotalResult[0]);
          $(".header__secondary-links .header__icon-wrapper[aria-controls='search-drawer']").append(newSpanTotalResult);
        }
      }
    }, 100);
  }

  // if ($('.template-collection').length > 0) {
  //   let checkExistFilterBlock = setInterval(function () {
  //     let filter_block = $('.boost-sd__filter-block .boost-sd-layout');
  //     if (filter_block.length > 0) {console.log(filter_block)
  //       clearInterval(checkExistFilterBlock);
  //       $('html,body').animate({scrollTop: 0},'slow');             
  //     }
  //   }, 100);
  // }
  
  // scroll to top
if (window.location.pathname === '/') {
    $("#js-ScrollTop").on("click", function () {
    const targetSection = $("#products");
    if (targetSection.length) {
      $("html, body").animate({ scrollTop: targetSection.offset().top -100 }, 1000);
    }
  });
} else {
    $("#js-ScrollTop").on("click", function () {
    $("html, body").animate({ scrollTop: -2 }, 1000);
  });
}
  
  
})
$(window).on('load', function() {
  if (window.location.hash != '' && $('.shopify-section--customBlogPost').length > 0) {
    const targetSection = $(window.location.hash);
    
    $('html, body').animate({
      scrollTop: targetSection.offset().top - 100
    }, 1000);
  }
});

  // scroll to top
  if (window.location.pathname === "/") {
    $("#js-ScrollTop").on("click", function () {
      const targetSection = $("#products");
      if (targetSection.length) {
        $("html, body").animate(
          { scrollTop: targetSection.offset().top - 100 },
          1000
        );
      }
    });
  } else if (window.location.pathname.match(/collections/gi)) {
    // const firstTimeVisitCollection = sessionStorage.getItem(
    //   "first-time-visit-collection"
    // );

    // if (firstTimeVisitCollection) {
    //   $(window).on("load", function () {
    //     const targetSection = $("#collection-banner");
    //     if (targetSection.length) {
    //       $("html,body").animate(
    //         { scrollTop: targetSection.offset().top },
    //         "slow"
    //       );
    //     }
    //   });
    // } else {
    //   sessionStorage.setItem("first-time-visit-collection", "true");
    // }

    $("#js-ScrollTop").on("click", function () {
      const targetSection = $("#collection-banner");
      if (targetSection.length) {
        $("html, body").animate(
          { scrollTop: targetSection.offset().top },
          "slow"
        );
      }
    });
  } else {
    $("#js-ScrollTop").on("click", function () {
      $("html, body").animate({ scrollTop: -2 }, 1000);
    });
  }

window.addEventListener('DOMContentLoaded', async () => {
  $('.mobile-toolbar__item--sort').click(function () {
    $('.boost-sd__sorting-button').trigger('click');
  });
  $('.mobile-toolbar__item--filters').click(function () {
    $('.boost-sd__filter-tree-toggle-button').trigger('click');
  });
});

if ($('.tab-custom .tab-title').length > 0) {
  const tabCusstom = document.querySelectorAll('.tab-custom .tab-title');
  tabCusstom.forEach(question => {
      question.addEventListener('click', () => {
          question.classList.add('is-active');
          const answer = question.nextElementSibling;
          answer.style.opacity = (answer.style.opacity === '1') ? '0' : '1';
          answer.style.visibility = (answer.style.visibility === 'visible') ? 'hidden' : 'visible';
          answer.style.height = (answer.style.height === '100%') ? '0' : '100%';
          if ( answer.style.height === '100%'){
            question.classList.add('is-active');
          }else{
              question.classList.remove('is-active');
          }
      });
  });
}

// instance search
(()=> {
  let checkExistFilterBlock = setInterval(function () {
      let filter_block = $('#boost-sd__instant-search-container');
      const closeBtn = $('button.drawer__close-button.tap-area')
      if (filter_block.length > 0) {
        clearInterval(checkExistFilterBlock);
        filter_block.insertAfter("#search-drawer .drawer__header");
       
      }
  }, 100);
})();

(()=> {
   let checkExistFilterBlock = setInterval(function () {
      let filter_block = $('#boost-sd__search-bar-input');
       
      if (filter_block.length > 0) {
        clearInterval(checkExistFilterBlock);
        $("button.drawer__close-button.drawer__close-button--block.tap-area").insertAfter(filter_block)
      }
  }, 100);
 
})()
